/* globals jQuery, REAL */
jQuery( $ => {
	const $body = $( 'body' );

	$body.removeClass( 'nojs' ).addClass( 'js' );

	const headerHeight = $( '#real_header' ).outerHeight() || 0;
	const scrollOffset = $( 'body' ).hasClass( 'admin-bar' ) ? 32 : 0;

	setTimeout( function() {
		const hash = window.location.hash;
		if ( hash === '#' ) {
			return;
		}

		const $target = $( hash );
		if ( $target.length > 0 ) {
			$( 'html,body' ).animate( { scrollTop: $target.offset().top - ( headerHeight + scrollOffset ) }, 100 );
			if ( $target.hasClass( 'accordion-header closed' ) ) {
				$target.click();
			}
		}
	}, 100 );

	$( 'a[href^="#"]' ).click( function( e ) {
		e.preventDefault();
		const target = $(this).attr( 'href' );

		if ( target === '#top' ) {
			$( 'html,body' ).animate( { scrollTop: 0 } );
			return;
		}

		const $target = $( target );

		if ( $target.length > 0 ) {
			if ( $target.parent().hasClass( 'accordion-header closed' ) ) {
				$target.parent().trigger( 'click' );
			} else if( $target.parents( '.accordion-wrapper' ).length > 0 ) {
				$target.parents( '.accordion-wrapper' ).prev( '.accordion-header.closed' ).trigger( 'click' );
			}

			$( 'html,body' ).animate( { scrollTop: $target.offset().top - ( headerHeight + scrollOffset ) } );
		}
	} );

	$( '.accordion-header' ).each( function() {
		var level = parseInt( this.tagName.toLowerCase().replace( 'h', '' ) );
		var stop = [ 'hr' ];
		while ( level > 1 ) {
			stop.push( 'h' + level );
			level--;
		}
		$( this ).nextUntil( stop.join( ',' ) + ', .clear' ).wrapAll( '<div class="accordion-wrapper"><div class="accordion-content"><div class="accordion-inner"></div></div></div>' );
		$( this ).addClass( 'closed' );
	} ).click( function() {
		$( this ).toggleClass( 'open closed' );
		$( this ).next( '.accordion-wrapper' ).find( '.accordion-content' ).animate( { height: 'toggle' } );
	} );

	$( '#real_nav_toggle' ).click( function() {
		$( 'body' ).toggleClass( 'real-nav-open' );
	} );

	$( '#real_notice .close' ).click( function() {
		$( 'body' ).removeClass( 'with-notice' );
		localStorage.setItem( 'seen_notice', true );
	} );

	$( '#real_search input' ).autocomplete( {
		appendTo: $( '#real_search .wrapper' ),
		delay: 300,
		source( request, response ) {
			$.ajax( {
				url: REAL.url_autocomplete,
				data: {
					query: request.term,
				},
				success( matches ) {
					var items = [];
					$.each( matches, function( i, match ) {
						items.push( {
							value: match.title,
							label: match.highlighted,
							url: match.url,
						} );
					} );

					response( items );
				},
			} );
		},
		select( event, ui ) {
			event.preventDefault();
			window.location = ui.item.url;
		},
		create() {
			$( this ).data( 'ui-autocomplete' )._renderItem = function( ul, item ) {
				return $( '<li>' ).html( item.label ).attr( 'title', item.value ).appendTo( ul );
			};
		},
	} );

	$( '.real-footnotes a[href^="#"]' ).each( function() {
		const $target = $( $( this ).attr( 'href' ) );

		if ( ! $target.length ) {
			$( this ).attr( 'disabled', true );
			return;
		}

		const title = $target.find( '.real-evidence-title' ).text();

		$( this ).attr( 'title', title );
	} );

	$( '.real-vote' ).click( function() {
		const $button = $( this ).attr( 'disabled', true );

		$.ajax( {
			url: REAL.url_vote,
			type: 'PUT',
			beforeSend: function ( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', REAL.nonce );
			},
			data: {
				review_id: $button.val(),
			},
			success( data ) {
				$button.text( data.text );
			},
		} );
	} );

	$( '.real-subscribe[value]' ).click( function() {
		const $button = $( this );

		$.ajax( {
			url: REAL.url_subscribe,
			type: 'PUT',
			beforeSend: function ( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', REAL.nonce );
			},
			data: {
				review_id: $button.val(),
				unsubscribe: $button.hasClass( 'is-subscribed' ),
			},
			success( data ) {
				$button.toggleClass( 'is-subscribed', data.subscribed );
			},
		} );
	} );

	$( '.real-save[value]' ).click( function() {
		const $button = $( this );

		$.ajax( {
			url: REAL.url_save,
			type: 'PUT',
			beforeSend: function ( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', REAL.nonce );
			},
			data: {
				review_id: $button.val(),
				unsave: $button.hasClass( 'is-saved' ),
			},
			success( data ) {
				$button.toggleClass( 'is-saved', data.saved );
			},
		} );
	} );

	// =========================
	// ! Filter Handling
	// =========================

	const $filters = $( '.real-filter' );

	$( '.real-filter__toggle' ).click( function() {
		$( this ).parent().toggleClass( 'in' ).trigger( 'app:toggle' );
	} );

	$filters.on( 'app:toggle', function() {
		if ( $( this ).hasClass( 'in' ) ) {
			$filters.not( this ).removeClass( 'in' );
		}

		$body.toggleClass( 'showing-filter', $filters.filter( '.in' ).length > 0 );
	} );

	$filters.on( 'input', function() {
		$( this ).toggleClass( 'has-checked', $( this ).find( 'input:checked' ).length > 0 );
	} ).trigger( 'input' );

	$( '.real-filter__clear' ).click( function() {
		$( this ).parents( '.real-filter' ).find( 'input' ).each( function() {
			this.checked = false;
		} );
	} );

	$( '.real-filter-search__input' ).each( function() {
		$( this ).autocomplete( {
			minLength: 0,
			source: $( this ).data( 'autocomplete' ),
			appendTo: $( this ).parent(),
			select( event, ui ) {
				event.preventDefault();
				window.location = ui.item.url;
			},
			open( event, ui ) {
				$( event.target ).addClass( 'show-results' );
			},
			close( event, ui ) {
				$( event.target ).removeClass( 'show-results' );
			},
		} ).focus( function() {
			$( this ).autocomplete( 'search', this.value );
		} );
	} );

	$( '.real-filter-reset' ).click( function() {
		$( '.real-filter' ).find( 'input' ).attr( 'checked', false );
		$( '#filters' ).submit();
	} );

	$( '.real-filter-tag' ).click( function() {
		$( `input[name="${ this.name }[]"][value="${ this.value }"]` ).attr( 'checked', false ).trigger( 'input' );
		$( '#filters' ).submit();
	} );

	// =========================
	// ! Special Events
	// =========================

	$( '.real-directory-item' ).click( function( e ) {
		if ( $( e.target ).is( 'a' ) || $( e.target ).is( 'button' ) ) {
			return;
		}

		$( this ).find( '.real-directory-item__title a' ).click();
	} );

	$( document ).click( function( e ) {
		const $target = $( e.target );
		if ( ! $target.is( '[href^="#"]' ) && ! $target.hasClass( 'in' ) && $target.parents( '.in' ).length === 0 ) {
			$( '.in' ).removeClass( 'in' ).trigger( 'app:toggle' );
		}
	} );
} );
